import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import styled from "styled-components";
import NativeObject from "../../components/NativeObject/NativeObject";
import Card from "../../components/Cards/Card";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  padding-right: 10px;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "94%",
  justifyContent: "flex-start",
  width: "100%",
});

function OpportunitiesDesktop({ app, config }) {
  return (
    <div className="app oportunidades">
      <div className="appContent">
        <LayoutCardsWrapper>
          <Grid container rowGap={2} marginTop={"29px"}>
            <Grid item width={"50%"} paddingLeft={"20px"}>
              <LayoutCardWrapper>
                <Card
                  app={app}
                  header={{
                    hardTitle:
                      "Distribuidores com pior aproveitamento em Acelera ",
                  }}
                  exportTable
                  exportTableId={"VnCaJ"}
                  exportContainer
                  style={{ width: "100%", height: "100%" }}
                  className={"container-table"}
                >
                  <NativeObject
                    app={app}
                    key="VnCaJ"
                    reference={{ id: "VnCaJ" }}
                    style={{ height: "calc(100vh - 200px)" }}
                  />
                </Card>
              </LayoutCardWrapper>
            </Grid>

            <Grid item width={"50%"}>
              <LayoutCardWrapper className={"container-table"}>
                <Card
                  app={app}
                  header={{
                    hardTitle: "Vendedores com pior aproveitamento em Acelera",
                  }}
                  exportTable
                  exportTableId={"wkxpEC"}
                  exportContainer
                  style={{ width: "100%", height: "100%" }}
                  className={"container-table"}
                >
                  <NativeObject
                    app={app}
                    key="wkxpEC"
                    reference={{ id: "wkxpEC" }}
                    style={{ height: "calc(100vh - 200px)" }}
                  />
                </Card>
              </LayoutCardWrapper>
            </Grid>
          </Grid>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

OpportunitiesDesktop.defaultProps = {
  app: null,
  config: {},
};

OpportunitiesDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default OpportunitiesDesktop;
